<template>
	<VueHtml2pdf
		ref="html2Pdf"
		:show-layout="false"
		:float-layout="true"
		:enable-download="false"
		:preview-modal="true"
		:paginate-elements-by-height="1400"
		:filename="filename"
		:pdf-quality="2"
		:manual-pagination="false"
		:html-to-pdf-options="options"
		@beforeDownload="beforeDownload($event)"
	>
		<template slot="pdf-content">
			<v-app>
				<div class="mx-8 mt-8">
					<v-avatar size="48px">
						<img :src="logo"></img>
					</v-avatar>
					<span class="ml-4 text-h4">{{ logoTitle }}</span>

					<h2 class="text-center">{{ title }}</h2>

					<v-row no-gutters>
						<v-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
							№ {{ id }}
						</v-col>
						<v-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6" class="text-right">
							{{ item.datecreate | formatDateTime }}
						</v-col>
						<v-col cols="12" class="text-right">
							{{ username }}
						</v-col>
					</v-row>
				</div>

				<!-- <v-divider class="mx-8"></v-divider>

				<div class="mx-8 my-6" v-if="parameters.length">
					<div class="text-subtitle-1 font-weight-bold">Параметри</div>
					<v-simple-table dense>
						<template v-slot:default>
							<tbody>
								<tr v-for="(item, index) in parameters" :key="index">
									<td width="50%">{{ item.name }}</td>
									<td>{{ item.value }}</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</div> -->

				<v-divider class="mx-8"></v-divider>

				<div class="mx-8 my-6" v-if="bannerNoDataVisible">
					<v-avatar slot="icon" size="40">
						<v-icon icon="mdi-alert" color="warning">mdi-alert</v-icon>
					</v-avatar>
					<span>Транспортний засіб в єдиному державному реєстрі не знайдено.</span>
					<!-- <div>Спробуйте зробити оцінку за допомогою параметрів.</div> -->
					<!-- <template v-slot:actions>
						<v-btn text color="primary" :to="{name: 'VehicleAveragePriceCombo'}">
							Перейти
						</v-btn>
					</template> -->
				</div>

				<div class="mx-8 my-6">
					<!-- <div class="text-subtitle-1 font-weight-bold" v-if="registrations.length">Комплектація</div> -->
					<div v-if="registrations.length">
						<v-simple-table dense>
							<template v-slot:default>
								<tbody>
									<tr v-for="item in registrations" :key="item.code">
										<td  width="50%">{{ item.name }}</td>
										<td>{{ item.val }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</div>
				</div>
			</v-app>
		</template>
	</VueHtml2pdf>
</template>

<script>
import mixin from './mixin/main'
import VueHtml2pdf from 'vue-html2pdf' //https://www.npmjs.com/package/vue-html2pdf

export default {
	mixins: [mixin],
	components: { VueHtml2pdf },
	data: () => ({
		
	}),

	computed: {
		// Дані про державну реєстрацію транспортного засобу
		registrations() {
			return this.item.hasOwnProperty('registrations') ? this.item.registrations: [];
		},

		bannerNoDataVisible() {
			let result = false

			if(this.id) {
				result = this.item.registrations.length > 0 ? false : true
			}

			return result
		},
	},
}

</script>